import useDashboardWarning from '../../hooks/useDashboardWarning'
import background from './connected.webp'
import css from './Dashboard.module.css'

const Dashboard = () => {
  const warning = useDashboardWarning()

  return (
    <div className={css.main} data-view='full-screen'>
      <img className={css.bg} src={background} alt='background' />
      {warning && (
        <div className={css.warning}>
          <span className={css.warningText}>{warning}</span>
        </div>
      )}
    </div>
  )
}

export default Dashboard
